import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.invoices;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// /GetAllInvoicesByLocalId/<int:local_id>

/**
 * Fetch all invoices for a given localId and date range.
 * @param localId 
 * @param startDate YYYY-MM-DD
 * @param endDate   YYYY-MM-DD
 */
export const getAllInvoicesByLocalId = async (
  localId: number,
  startDate: string,
  endDate: string
) => {
  return await api.get(
    `/GetAllInvoicesByLocalId/${localId}/${startDate}/${endDate}`
  );
};

// /PrepareInvoiceEntitiesByInvoiceUuid/<string:invoice_uuid>

export const prepareInvoiceEntitiesByInvoiceUuid = async (invoiceUuid: string) => {
  return await api.get(`/PrepareInvoiceEntitiesByInvoiceUuidV2/${invoiceUuid}`);
};

// /ExecutePreparedInvoice post with a payload
export const executePreparedInvoice = async (payload: any) => {
  return await api.post('/ExecutePreparedInvoiceV2', payload);
}



// /GetInvoiceById/<int:invoice_id>
export const getInvoiceById = async (invoiceId: number) => {
  return await api.get(`/GetInvoiceById/${invoiceId}`);
}

// /DeleteInvoiceById/<int:invoice_id>

export const deleteInvoiceById = async (invoiceId: number) => {
  return await api.delete(`/DeleteInvoiceById/${invoiceId}`);
}

// /MoveRejectedToPending/<int:invoice_id>

export const moveRejectedToPending = async (invoiceId: number) => {
  return await api.post(`/MoveRejectedToPending/${invoiceId}`);
}

// /MoveInvoiceToPending/<int:invoice_id> 

export const moveInvoiceToPending = async (invoiceId: number) => {
  return await api.put(`/MoveInvoiceToPending/${invoiceId}`);
}

